import { YesNoNotSureOptions } from '@commenda/types/src/common/enums';
import { RootFiIntegration } from '@prisma/client';

export const COMMENDA_IO_EMAIL_DOMAIN = '@commenda.io';
export const COMMENDA_COMPANY_IDS = [1081];

export const MONTHS_FOR_SELECTION_INPUT = [
  { value: '1', displayedValue: 'January' },
  { value: '2', displayedValue: 'February' },
  { value: '3', displayedValue: 'March' },
  { value: '4', displayedValue: 'April' },
  { value: '5', displayedValue: 'May' },
  { value: '6', displayedValue: 'June' },
  { value: '7', displayedValue: 'July' },
  { value: '8', displayedValue: 'August' },
  { value: '9', displayedValue: 'September' },
  { value: '10', displayedValue: 'October' },
  { value: '11', displayedValue: 'November' },
  { value: '12', displayedValue: 'December' },
];

export const HIRE_PLAN_LABELS = {
  [YesNoNotSureOptions.Yes]: 'Yes',
  [YesNoNotSureOptions.No]: 'No',
  [YesNoNotSureOptions.NotSure]: "I'm not sure",
};


enum EnvironmentName {
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  DEMO = 'demo',
  PRODUCTION = 'production',
}

export function isProdLikeEnvironment(env: string) {
  if (env === EnvironmentName.PRODUCTION) return true;
  if (env === EnvironmentName.DEMO) return true;
  return false;
}

export const FRONTEND_ENTERPRISE_APP_URLS: Record<EnvironmentName, string> = {
  development: 'http://localhost:3000',
  staging: 'https://app.staging.commenda.io',
  demo: 'https://app.demo.commenda.io',
  production: 'https://app.commenda.io',
};

export const FRONTEND_AGENT_APP_URLS: Record<EnvironmentName, string> = {
  development: 'http://localhost:3004',
  staging: 'https://agent.staging.commenda.io',
  demo: 'https://agent.demo.commenda.io',
  production: 'https://agent.commenda.io',
};

export const FRONTEND_ADMIN_APP_URLS: Record<EnvironmentName, string> = {
  development: 'http://localhost:3002',
  staging: 'https://admin.staging.commenda.io',
  demo: 'https://admin.demo.commenda.io',
  production: 'https://admin.commenda.io',
};

export const REGEX_PATTERNS = {
  ifsccode: /^[A-Z]{4}[0-9][A-Z0-9]{6}$/,
  routingNumber: /^[A-Za-z]{4}[A-Z0-9a-z]{7}$/,
  swiftCode: /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/,
  email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
};

export const INTEGRATION_LOGOS = {
  TALLY: '/integration-icons/tally_logo_rounded.png',
  SAGE_CLOUD_ACCOUNTING: '/integration-icons/sage_logo_rounded.png',
  SAGE_ZA_CLOUD_ACCOUNTING: '/integration-icons/sage_logo_rounded.png',
  SAGE_INTACCT: '/integration-icons/sage_logo_rounded.png',
  ZOHO_BOOKS: '/integration-icons/zoho_books_logo_rounded.png',
  MYOB_BUSINESS: '/integration-icons/myob_logo_rounded.png',
  QUICKBOOKS: '/integration-icons/quickbooks_logo_rounded.png',
  QUICKBOOKS_SANDBOX: '/integration-icons/quickbooks_logo_rounded.png',
  XERO: '/integration-icons/xero_logo_rounded.png',
  MS_DYNAMICS_365: '/integration-icons/dynamics_logo_rounded.png',
  MS_DYNAMICS_365_FO: '/integration-icons/dynamics_f&o_rounded.svg',
  WAVE: '/integration-icons/wave_logo_rounded.png',
  ODOO_ACCOUNTING: '/integration-icons/odoo_logo_rounded.png',
  SHOPIFY: '/integration-icons/shopify_logo_rounded.svg',
  BUSY: '/integration-icons/busy_logo_rounded.svg',
  NETSUITE: '/integration-icons/oracle_netsuite.png',
  FLIPKART: '/integration-icons/odoo_logo_rounded.png',
  WAFEQ: '/integration-icons/wafeq_logo_rounded.png',
  MEKARI_JURNAL: '/integration-icons/jurnal_logo_rounded.svg',
  ROOTFI_SANDBOX: '/integration-icons/rootfisandbox_logo_rounded.svg',
  QOYOD: '/integration-icons/qoyod_logo_rounded.svg',
  STRIPE: '/integration-icons/stripe_logo_rounded.svg',
  PAYPAL: '/integration-icons/paypal_logo_rounded.svg',
  PAYPAL_SANDBOX: '/integration-icons/paypal_logo_rounded.svg',
  RAZORPAY: '/integration-icons/razorpay_logo_rounded.svg',
  ZOHO_CRM: '/integration-icons/zoho_crm_logo_rounded.svg',
  HUBSPOT: '/integration-icons/hubspot_logo_rounded.svg',
  PIPEDRIVE: '/integration-icons/pipedrive_logo_rounded.svg',
  CLEARBOOKS: '/integration-icons/clearbooks_rounded_logo.svg',
  FRESHBOOKS: '/integration-icons/freshbooks_logo_rounded.svg',
  FREEAGENT: '/integration-icons/free_agent_logo_rounded.svg',
  SQUARE: '/integration-icons/square_logo_rounded.svg',
  SQUARE_SANDBOX: '/integration-icons/square_logo_rounded.svg',
  BIG_COMMERCE: '/integration-icons/big_commerce_logo_rounded.svg',
  WOO_COMMERCE: '/integration-icons/woo_commerce_logo_rounded.svg',
  ZOHO_INVOICE: '/integration-icons/zoho_invoice_logo_rounded.svg',
  CHARGEBEE: '/integration-icons/chargebee_logo_rounded.svg',
  WIX: '/integration-icons/wix_logo_rounded.svg',
  SQUARESPACE: '/integration-icons/squarespace_logo_rounded.svg',
  AMAZON: '/integration-icons/amazon_logo_rounded.svg',
  MOLLIE: '/integration-icons/mollie_logo_rounded.svg',
  KASHFLOW: '/integration-icons/kashflow_rounded_logo.svg',
  SALES_FORCE: '/integration-icons/sales_force_logo_rounded.svg',
  GOOGLE_PLAYSTORE: '/integration-icons/google_playstore_logo_rounded.svg',
  PADDLE: '/integration-icons/paddle_logo_rounded.svg',
  PADDLE_SANDBOX: '/integration-icons/paddle_logo_rounded.svg',
  PUZZLE: '/integration-icons/puzzle_logo_rounded.png',
  PUZZLE_SANDBOX: '/integration-icons/puzzle_logo_rounded.png',
  RILLET: "/integration-icons/rillet_logo_rounded.png",
  RILLET_SANDBOX: "/integration-icons/rillet_logo_rounded.png",
  EPICOR_PROPHET_21: '/integration-icons/epicor_prophet_21_logo_rounded.png',
};

export const INTEGRATION_TUTORIAL_URLS: Partial<Record<RootFiIntegration, string>> = {
  QUICKBOOKS: 'https://app.arcade.software/share/H76V2Bp4Lo8QkzvQUZiy',
  QUICKBOOKS_SANDBOX: 'https://app.arcade.software/share/H76V2Bp4Lo8QkzvQUZiy',
};
